<template>
    <sa-page-layout btnRefreshVisible @refresh="onRefresh" :linkedit="linkedit" btnNewVisible>
        <!-- <template slot="toolbar">
      <b-button @click="onOpenModalDatiDocumenti" size="sm" class="float-sm-right" variant="success btn-toolbar"> <b-icon icon="plus"></b-icon>Nuovo</b-button>
    </template> -->


        <template slot="table-filter">

            <b-form @submit.prevent="onSubmit">
                <div class="sa-form-section sa-search-box">
                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                                <label class="sa-search-box-label">Struttura</label>
                                <div class="sa-page-search-component-wrapper">
                                    <b-form-select class="sa-search-input mb-2 mr-sm-2 mb-sm-0"
                                        v-model="filtroDocumenti.strutturaCodice" :options="strutturaOptions"
                                        :value="null" value-field="codiceStruttura" text-field="denominazione">
                                        <template #first>
                                            <b-form-select-option :value="null">- Tutte -</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-search-box-label">Data Dal</label>
                            <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtroDocumenti.dataDal"
                                type="datetime" placeholder="Data Dal"></date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-search-box-label">Data Al</label>
                            <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtroDocumenti.dataAl"
                                type="datetime" placeholder="Data Al"></date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-search-box-label">Numero Documento</label>
                            <div class="sa-search-search-wrapper">
                                <input class="sa-search-box-input" v-model="filtroDocumenti.numeroDocumento"
                                    type="search" id="numeroDocumento" placeholder="Numero Documento" />
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                                <label class="sa-search-box-label">Tipo Documento</label>
                                <div class="sa-page-search-component-wrapper">
                                    <b-form-select v-model="filtroDocumenti.idTipoDocumento"
                                        :options="contabilitaTipoDocumentoOptions"
                                        class="sa-search-input mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id"
                                        text-field="descrizioneTipoDocumento">
                                        <template #first>
                                            <b-form-select-option :value="null">- Tutti -</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </div>
                            </div>

                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-search-box-label">Ragione Sociale</label>
                            <div class="sa-search-search-wrapper">
                                <input class="sa-search-box-input" v-model="filtroDocumenti.cognomeRagioneSoggetto"
                                    type="search" id="ragioneSoggetto" placeholder="Ragione Sociale" />
                            </div>

                        </b-col>
                    </b-row>
                    <b-row class="sa-form-btn-filter">
                        <b-col class="sa-padding-right text-right">
                            <b-button type="submit" variant="info">Cerca</b-button>
                            <b-button type="reset" v-on:click="onReset" variant="danger">Resetta Filtro</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-form>

            <sa-modal-loading ref="mdlSaModalLoading"></sa-modal-loading>
        </template>
        <template slot="table-body">
            <contabilita-documenti-list-component ref="cmpContabilitaDocumentiListComponent"
                @afterLoadData="onAfterLoadDataContabilitaDocumentiListComponent"></contabilita-documenti-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ContabilitaDocumentiListComponent from "../components/ContabilitaDocumentiListComponent.vue";
import DatePicker from "vue2-datepicker";
import { SaModalLoading } from "../../utility";
import UtilityMixin from "../../utility/UtilityMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";

export default {
    mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin],
    components: { SaPageLayout, DatePicker, SaModalLoading, ContabilitaDocumentiListComponent },

    data() {
        return {

            presidio: null,
            linkedit: "/contabilita/documenti",
            filtroDocumenti: { strutturaCodice: null, dataDal: null, dataAl: null, numeroDocumento: null, idTipoDocumento: null, cognomeRagioneSoggetto: null },
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        let filtroDocumenti = sessionStorage.getItem("filtroDocumenti");
        if (filtroDocumenti) {
            this.filtroDocumenti = JSON.parse(filtroDocumenti);
        }
        this.struttureLoadData();
        this.loadDefaulData();
    },
    methods: {
        loadDefaulData() {
            this.getPresidio();
            if (this.presidio) {
                this.filtroDocumenti.strutturaCodice = this.presidio.codiceStruttura;
            }
            this.contabilitaTipoDocumentoLoadData(this.filtroDocumenti.strutturaCodice);
            this.loadData();
        },
        loadData() {
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroDocumenti", JSON.stringify(this.filtroDocumenti));

            this.$refs.cmpContabilitaDocumentiListComponent.loadData(this.filtroDocumenti);
        },
        onRefresh() {
            let me = this;
            let filter = sessionStorage.getItem("filtroDocumenti");
            filter = JSON.parse(filter);
            me.$refs.cmpContabilitaDocumentiListComponent.refresh(filter);
        },
        onSubmit() {

            this.loadData();
        },
        onReset() {
            this.filtroDocumenti = { dataDal: null, dataAl: null, numeroDocumento: null, idTipoDocumento: null, cognomeRagioneSoggetto: null };
            this.filtroDocumenti.strutturaCodice = this.presidio.codiceStruttura;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroDocumenti", JSON.stringify(this.filtroDocumenti));

            this.loadData();
        },
        onAfterLoadDataContabilitaDocumentiListComponent() {
            this.$refs.mdlSaModalLoading.close();
        },
        getPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
    },
};
</script>

<style></style>
